import React from 'react';
import { ClipboardCheck } from 'lucide-react';
import type { PluginDefinition } from '@/plugins/types';
import { APP_VERSION } from '@/app/version';

const StewardReviewPage = React.lazy(
  () => import('@/app/features/steward/StewardReviewPage').then((module) => ({ default: module.StewardReviewPage })),
);

const fallback = (
  <div className="flex h-full items-center justify-center text-muted-foreground text-sm">
    Lädt…
  </div>
);

export const stewardPlugin: PluginDefinition = {
  id: 'steward',
  name: 'Sopho Steward',
  version: APP_VERSION,
  description: 'Review-Queue, Entity-Validierung und Freigabe für extrahiertes Wissen.',
  internal: true,
  group: 'data',
  // DevPlan 0139/T3: workspace-bezogenes Stewardship-Tool → WS-Rolle statt Org-Rolle.
  // Sichtbarkeit (Review-Queue ansehen/triagieren) ab WS-Editor.
  // DevPlan 0139/T2: Freigabe-/Governance-Aktionen sind Separation-of-Duties-pflichtig
  // → WS-Reviewer (Server: StewardController autoritativ; Frontend = Defense-in-Depth).
  accessControl: {
    minWorkspaceRole: 'Editor',
    // DeleteReport bleibt WS-Editor (Interviewer-Selfservice "neu generieren") → kein
    // Feature-Gate (= Plugin-Sichtbarkeit). Nur die echten Freigaben sind Reviewer.
    features: {
      'approve-entity': { minWorkspaceRole: 'Reviewer' },
      'reject-entity': { minWorkspaceRole: 'Reviewer' },
      'finalize-report': { minWorkspaceRole: 'Reviewer' },
      'mark-outdated': { minWorkspaceRole: 'Reviewer' },
    },
  },
  initializationOrder: 45,
  initialize: () => undefined,
  navigation: [
    {
      id: 'steward',
      label: 'Sopho Steward',
      path: '/app/steward',
      icon: ClipboardCheck,
      order: 45,
    },
  ],
  routes: [
    {
      id: 'steward',
      path: 'steward',
      element: <React.Suspense fallback={fallback}><StewardReviewPage /></React.Suspense>,
    },
  ],
};